import {
  getTimelineWindowHourLabels,
  TIMELINE_HEADER_HEIGHT_PX,
} from '../lib/timeline';
import { TimelineGridLines } from './timeline-grid-lines';

interface TimeAxisHeaderProps {
  hourWidthPx: number;
  timelineWidthPx: number;
}

export function TimeAxisHeader({
  hourWidthPx,
  timelineWidthPx,
}: TimeAxisHeaderProps) {
  const hours = getTimelineWindowHourLabels();

  const formatHourLabel = (hour: number) => {
    if (hour === 0 || hour === 12) return '12';
    if (hour < 12) return String(hour);
    return String(hour - 12);
  };

  const formatPeriod = (hour: number) => (hour < 12 ? 'AM' : 'PM');

  return (
    <div
      className='relative bg-background'
      style={{
        width: timelineWidthPx,
        minWidth: timelineWidthPx,
        height: TIMELINE_HEADER_HEIGHT_PX,
      }}
    >
      <TimelineGridLines
        hourWidthPx={hourWidthPx}
        timelineWidthPx={timelineWidthPx}
      />
      <div className='relative flex h-full'>
        {hours.map((hour) => (
          <div
            key={hour}
            className='flex h-full shrink-0 items-center justify-start px-2 text-sm font-medium'
            style={{ width: hourWidthPx }}
          >
            {formatHourLabel(hour)}
            {formatPeriod(hour)}
          </div>
        ))}
      </div>
    </div>
  );
}
